module.exports = __webpack_public_path__ + "img/P4-3.51e15133.jpg";